import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const DeleteProductSlice = createSlice({
    name: "deleteProductRequest",
    initialState,
    reducers: {
        deleteProductRequest(state) {
            state.loading = true;
        },
        deleteProductRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        deleteProductRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        deleteProductStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    deleteProductRequest,
    deleteProductRequestSuccess,
    deleteProductRequestError,
    deleteProductStateReset,
} = DeleteProductSlice.actions;

export default DeleteProductSlice.reducer;
